/* -=-=-=-=-==-=-=-=-    Local Action Types    -=-=-=-=-==-=-=-=- */

//Loader
export const SET_LOADING_STATUS = 'LOADER/SET_LOADING_STATUS';
export const REMOVE_LOADING_STATUS = 'LOADER/REMOVE_LOADING_STATUS';

// Set Visibility of Change Language Screen
export const SET_CHANGE_LANGUAGE_VISIBILITY = 'CHANGE_LANGUAGE/SET_CHANGE_LANGUAGE_VISIBILITY';

// Set General details
export const SET_GENERAL_DETAILS = 'GENERAL_DETAILS/SET_GENERAL_DETAILS';
export const SET_SELECTED_OFFER = 'OFFERS/SET_SELECTED_OFFER';
export const SET_ALL_OFFERS = 'OFFERS/SET_ALL_OFFERS';

// Feature Access
export const SET_FEATURE_ACCESS = 'FEATURE_ACCESS/SET_FEATURE_ACCESS';

//
export const SET_CAMPAIGN_STATUS = 'CAMPAIGN_STATUS/SET_CAMPAIGN_STATUS';

// Set Coach Marker details
export const SET_COACHMARKER_DETAILS = 'COACH_MARKERS/SET_COACH_MARKERS';
export const TRIGGER_COACHMARKS_SHOWN = 'HOME_DETAILS/TRIGGER_COACHMARKS_SHOWN';
export const SET_LOADPAY_COACHMARKER_DETAILS = 'COACH_MARKERS/SET_LOADPAY_COACHMARKER_DETAILS';
export const TRIGGER_LOADPAY_COACHMARKS_SHOWN = 'HOME_DETAILS/TRIGGER_LOADPAY_COACHMARKS_SHOWN';
/* -=-=-=-=-==-=-=-=-    Api Action Types    -=-=-=-=-==-=-=-=- */

//Trigger Home Details Api
export const TRIGGER_HOME_DETAILS_API = 'HOME_DETAILS/TRIGGER_HOME_DETAILS_API';
export const TRIGGER_HOME_DETAILS_API_SUCCESS = 'HOME_DETAILS/TRIGGER_HOME_DETAILS_API_SUCCESS';

//Trigger Validate Pan Api
export const TRIGGER_VALIDATE_PAN_API = 'VALIDATE_PAN/TRIGGER_VALIDATE_PAN_API';
export const TRIGGER_VALIDATE_PAN_API_SUCCESS = 'VALIDATE_PAN/TRIGGER_VALIDATE_PAN_API_SUCCESS';

//Trigger Pan Save Api
export const TRIGGER_PAN_SAVE_API = 'PAN_SAVE/TRIGGER_PAN_SAVE_API';
export const TRIGGER_PAN_SAVE_API_SUCCESS = 'PAN_SAVE/TRIGGER_PAN_SAVE_API_SUCCESS';

//Trigger Fetch Bank List Api
export const TRIGGER_FETCH_BANK_LIST_API = 'BANK_LIST/TRIGGER_FETCH_BANK_LIST_API';
export const TRIGGER_FETCH_BANK_LIST_API_SUCCESS = 'BANK_LIST/TRIGGER_FETCH_BANK_LIST_API_SUCCESS';

//Trigger Init Bank Details Api
export const TRIGGER_INIT_BANK_DETAILS_API = 'BANK_Details/TRIGGER_INIT_BANK_DETAILS_API';
export const TRIGGER_INIT_BANK_DETAILS_API_SUCCESS = 'BANK_Details/TRIGGER_INIT_BANK_DETAILS_API_SUCCESS';

//Trigger Validate Vpa Api
export const TRIGGER_VALIDATE_VPA_API_CALL = 'VALIDATE_VPA/TRIGGER_VALIDATE_VPA_API_CALL';
export const TRIGGER_VALIDATE_VPA_API_CALL_SUCCESS = 'VALIDATE_VPA/TRIGGER_VALIDATE_VPA_API_CALL_SUCCESS';
export const TRIGGER_CLEAR_MERCHANT_INFO_DETAILS = 'VALIDATE_VPA/TRIGGER_CLEAR_MERCHANT_INFO_DETAILS';

//Trigger Initiate Payment Api
export const TRIGGER_INITIATE_PAYMENT_API_CALL = 'PAYMENT/TRIGGER_INITIATE_PAYMENT_API_CALL';
export const TRIGGER_INITIATE_PAYMENT_API_CALL_SUCCESS = 'PAYMENT/TRIGGER_INITIATE_PAYMENT_API_CALL_SUCCESS';

//Trigger Txn Status Api
export const TRIGGER_TXN_STATUS_API_CALL = 'TXN_STATUS/TRIGGER_TXN_STATUS_API_CALL';
export const TRIGGER_TXN_STATUS_API_CALL_SUCCESS = 'TXN_STATUS/TRIGGER_TXN_STATUS_API_CALL_SUCCESS';
export const TRIGGER_CLEAR_TXN_DETAILS = 'TXN_STATUS/TRIGGER_CLEAR_TXN_DETAILS';

//Trigger Fetch Transaction List Api
export const TRIGGER_FETCH_TXN_LIST_API = 'TXN_LIST/TRIGGER_FETCH_TXN_LIST_API';
export const TRIGGER_FETCH_TXN_LIST_API_SUCCESS = 'TXN_LIST/TRIGGER_FETCH_TXN_LIST_API_SUCCESS';
export const CLEAR_TXN_LIST = 'TXN_LIST/CLEAR_TXN_LIST';

//Trigger Fetch Bank List Api
export const TRIGGER_NON_BP_MERCHANT_INFO_API = 'NON_BP_MERCHANT/TRIGGER_NON_BP_MERCHANT_INFO_API';
export const TRIGGER_NON_BP_MERCHANT_INFO_API_SUCCESS = 'NON_BP_MERCHANT/TRIGGER_NON_BP_MERCHANT_INFO_API_SUCCESS';

//Trigger Fetch Kyc Status Api
export const TRIGGER_FETCH_KYC_STATUS_API = 'KYC/TRIGGER_FETCH_KYC_STATUS_API';
export const TRIGGER_FETCH_KYC_STATUS_API_SUCCESS = 'KYC/TRIGGER_FETCH_KYC_STATUS_API_SUCCESS';

//Trigger Initiate Payment Api
export const TRIGGER_INITIATE_REPAYMENT_API_CALL = 'REPAYMENT/TRIGGER_INITIATE_REPAYMENT_API_CALL';
export const TRIGGER_INITIATE_REPAYMENT_API_CALL_SUCCESS = 'REPAYMENT/TRIGGER_INITIATE_REPAYMENT_API_CALL_SUCCESS';

//Trigger Repayment Status Api
export const TRIGGER_REPAYMENT_STATUS_API_CALL = 'REPAYMENT_STATUS/TRIGGER_REPAYMENT_STATUS_API_CALL';
export const TRIGGER_REPAYMENT_STATUS_API_CALL_SUCCESS = 'REPAYMENT_STATUS/TRIGGER_REPAYMENT_STATUS_API_CALL_SUCCESS';

//Trigger Bill Status Api
export const TRIGGER_FETCH_BILL_DETAILS_API = 'BILL_DETAILS/TRIGGER_FETCH_BILL_DETAILS_API';
export const TRIGGER_FETCH_BILL_DETAILS_API_SUCCESS = 'BILL_DETAILS/TRIGGER_FETCH_BILL_DETAILS_API_SUCCESS';

//Trigger Bill Status Api
export const TRIGGER_FETCH_CARD_DETAILS_API = 'CARD_DETAILS/TRIGGER_FETCH_CARD_DETAILS_API';
export const TRIGGER_FETCH_CARD_DETAILS_API_SUCCESS = 'CARD_DETAILS/TRIGGER_FETCH_CARD_DETAILS_API_SUCCESS';

//Trigger Order Card Address Details Api
export const TRIGGER_ORDER_CARD_ADDRESS_DETAILS_API = 'ORDER_CARD/TRIGGER_ORDER_CARD_ADDRESS_DETAILS_API';
export const TRIGGER_ORDER_CARD_ADDRESS_DETAILS_API_SUCCESS =
	'ORDER_CARD/TRIGGER_ORDER_CARD_ADDRESS_DETAILS_API_SUCCESS';

//Rate Transaction
export const TRIGGER_RATE_TRANSACTION_API = 'RATE/TRIGGER_RATE_TRANSACTION_API';
export const TRIGGER_RATE_TRANSACTION_API_SUCCESS = 'RATE/TRIGGER_RATE_TRANSACTION_API_SUCCESS';

//Trigger Fetch Pincode Details Api
export const TRIGGER_FETCH_PINCODE_DETAILS_API = 'PINCODE_DETAILS/TRIGGER_FETCH_PINCODE_DETAILS_API';
export const TRIGGER_FETCH_PINCODE_DETAILS_API_SUCCESS = 'PINCODE_DETAILS/TRIGGER_FETCH_PINCODE_DETAILS_API_SUCCESS';

//Trigger Sign Agreement Api
export const TRIGGER_SIGN_AGREEMENT_API = 'AGREEMENT/TRIGGER_SIGN_AGREEMENT_API';
export const TRIGGER_SIGN_AGREEMENT_API_SUCCESS = 'AGREEMENT/TRIGGER_SIGN_AGREEMENT_API_SUCCESS';

//Trigger Sign PrePaid Agreement Api
export const TRIGGER_SIGN_PREPAID_AGREEMENT_API = 'AGREEMENT/TRIGGER_SIGN_PREPAID_AGREEMENT_API';
export const TRIGGER_SIGN_PREPAID_AGREEMENT_API_SUCCESS = 'AGREEMENT/TRIGGER_SIGN_PREPAID_AGREEMENT_API_SUCCESS';

//Trigger Add Money Api
export const TRIGGER_ADD_MONEY_API = 'MONEY/TRIGGER_ADD_MONEY_API';
export const TRIGGER_ADD_MONEY_API_SUCCESS = 'MONEY/TRIGGER_ADD_MONEY_API_SUCCESS';

//Trigger PrePaid Txn Status Api
export const TRIGGER_PREPAID_TXN_STATUS_API_CALL = 'PREPAID_TXN_STATUS/TRIGGER_PREPAID_TXN_STATUS_API_CALL';
export const TRIGGER_PREPAID_TXN_STATUS_API_CALL_SUCCESS =
	'PREPAID_TXN_STATUS/TRIGGER_PREPAID_TXN_STATUS_API_CALL_SUCCESS';
export const TRIGGER_CLEAR_PREPAID_TXN_DETAILS = 'PREPAID_TXN_STATUS/TRIGGER_CLEAR_PREPAID_TXN_DETAILS';

//Trigger Fetch PrePaid Txn List Api
export const TRIGGER_FETCH_PREPAID_TXN_LIST_API = 'TXN_LIST/TRIGGER_FETCH_PREPAID_TXN_LIST_API';
export const TRIGGER_FETCH_PREPAID_TXN_LIST_API_SUCCESS = 'TXN_LIST/TRIGGER_FETCH_PREPAID_TXN_LIST_API_SUCCESS';

//Trigger Initiate Payment Api
export const TRIGGER_INITIATE_PREPAID_PAYMENT_API_CALL = 'PAYMENT/TRIGGER_INITIATE_PREPAID_PAYMENT_API_CALL';
export const TRIGGER_INITIATE_PREPAID_PAYMENT_API_CALL_SUCCESS =
	'PAYMENT/TRIGGER_INITIATE_PREPAID_PAYMENT_API_CALL_SUCCESS';

//Trigger Switch Account Api
export const TRIGGER_SWITCH_ACCOUNT_API = 'SWITCH_ACCOUNT/TRIGGER_SWITCH_ACCOUNT_API';
export const TRIGGER_SWITCH_ACCOUNT_API_SUCCESS = 'SWITCH_ACCOUNT/TRIGGER_SWITCH_ACCOUNT_API_SUCCESS';

//Trigger Send Money Api
export const TRIGGER_SEND_MONEY_API = 'SEND_MONEY/TRIGGER_SEND_MONEY_API';
export const TRIGGER_SEND_MONEY_API_SUCCESS = 'SEND_MONEY/TRIGGER_SEND_MONEY_API_SUCCESS';
export const TRIGGER_SEND_MONEY_API_FAILURE = 'SEND_MONEY/TRIGGER_SEND_MONEY_API_FAILURE';

//Trigger Send Money Bank List Api
export const TRIGGER_SEND_MONEY_BANK_LIST_API = 'SEND_MONEY/TRIGGER_SEND_MONEY_BANK_LIST_API';
export const TRIGGER_SEND_MONEY_BANK_LIST_API_SUCCESS = 'SEND_MONEY/TRIGGER_SEND_MONEY_BANK_LIST_API_SUCCESS';

//Trigger Send Money Bank Details Api
export const TRIGGER_INIT_SEND_MONEY_BANK_DETAILS_API = 'SEND_MONEY/TRIGGER_INIT_SEND_MONEY_BANK_DETAILS_API';
export const TRIGGER_INIT_SEND_MONEY_BANK_DETAILS_API_SUCCESS =
	'SEND_MONEY/TRIGGER_INIT_SEND_MONEY_BANK_DETAILS_API_SUCCESS';

//Trigger Send Money Transaction Status Api
export const TRIGGER_SET_SEND_MONEY_TRANSACTION_STATUS_DETAILS =
	'SEND_MONEY/TRIGGER_SET_SEND_MONEY_TRANSACTION_STATUS_DETAILS';
export const TRIGGER_CLEAR_SEND_MONEY_TXN_DETAILS = 'SEND_MONEY/TRIGGER_CLEAR_SEND_MONEY_TXN_DETAILS';

//Trigger Validate Mobile Api
export const TRIGGER_VALIDATE_MOBILE_API_CALL = 'VALIDATE_MOBILE/TRIGGER_VALIDATE_MOBILE_API_CALL';
export const TRIGGER_VALIDATE_MOBILE_API_CALL_SUCCESS = 'VALIDATE_MOBILE/TRIGGER_VALIDATE_MOBILE_API_CALL_SUCCESS';

//Trigger Fetch Bank Details Api
export const TRIGGER_FETCH_MATCH_DETAILS_API = 'T20/TRIGGER_FETCH_MATCH_DETAILS_API';
export const TRIGGER_FETCH_MATCH_DETAILS_API_SUCCESS = 'T20/TRIGGER_FETCH_MATCH_DETAILS_API_SUCCESS';
export const TRIGGER_CLEAR_MATCH_DETAILS = 'T20/TRIGGER_CLEAR_MATCH_DETAILS';

//Trigger Initiate Match Payment Api
export const TRIGGER_INITIATE_MATCH_PAYMENT_API = 'T20/TRIGGER_INITIATE_MATCH_PAYMENT_API';
export const TRIGGER_INITIATE_MATCH_PAYMENT_API_SUCCESS = 'T20/TRIGGER_INITIATE_MATCH_PAYMENT_API_SUCCESS';

//Trigger Fetch Ineligible Details Api
export const TRIGGER_FETCH_INELIGIBLE_DETAILS_API = 'INELIGIBLE_DETAILS/TRIGGER_FETCH_INELIGIBLE_DETAILS_API';
export const TRIGGER_FETCH_INELIGIBLE_DETAILS_API_SUCCESS =
	'INELIGIBLE_DETAILS/TRIGGER_FETCH_INELIGIBLE_DETAILS_API_SUCCESS';

//Trigger Fetch PostPe Contact List Api
export const TRIGGER_FETCH_POSTPE_CONTACT_LIST_API = 'CONTACT_LIST/TRIGGER_FETCH_POSTPE_CONTACT_LIST_API';
export const TRIGGER_FETCH_POSTPE_CONTACT_LIST_API_SUCCESS =
	'CONTACT_LIST/TRIGGER_FETCH_POSTPE_CONTACT_LIST_API_SUCCESS';

//Trigger Send Referrals Api
export const TRIGGER_SEND_REFERRALS_API_CALL = 'CONTACT_LIST/TRIGGER_SEND_REFERRALS_API_CALL';
export const TRIGGER_SEND_REFERRALS_API_CALL_SUCCESS = 'CONTACT_LIST/TRIGGER_SEND_REFERRALS_API_CALL_SUCCESS';

//Fetch Repayment History
export const TRIGGER_FETCH_REPAYMENT_HISTORY_API = 'REPAYMENT_HISTORY/TRIGGER_FETCH_REPAYMENT_HISTORY_API';
export const TRIGGER_FETCH_REPAYMENT_HISTORY_API_SUCCESS =
	'REPAYMENT_HISTORY/TRIGGER_FETCH_REPAYMENT_HISTORY_API_SUCCESS';
export const CLEAR_REPAYMENT_HISTORY = 'REPAYMENT_HISTORY/CLEAR_REPAYMENT_HISTORY';

//C1Banner
export const SET_C1_BANNERS = 'C1_BANNER/SET_C1_BANNER';

// CCBP via send money

export const SET_CCBP_AMOUNT = 'CCBP/SET_CCBP_AMOUNT';
export const SET_CCBP_C1_BANNER = 'CCBP/SET_CCBP_C1_BANNER';
export const SET_CCBP_PAYMENT_MODE = 'CCBP/SET_CCBP_PAYMENT_MODE';
export const SET_SM_TXN_STATUS = 'CCBP/SET_SM_TXN_STATUS';
export const SET_CCBP_TXN_STATUS = 'CCBP/SET_CCBP_TXN_STATUS';
export const SET_CCBP_NEW_ORDER = 'CCBP/SET_CCBP_NEW_ORDER';
export const SET_CCBP_SELECTED_BANK = 'CCBP/SET_CCBP_SELECTED_BANK';
export const SET_CCBP_SELECTED_ORDER = 'CCBP/SET_CCBP_SELECTED_ORDER';
export const SET_CCBP_SELECTED_CARD = 'CCPB/SET_CCBP_SELECTED_CARD';
export const SET_PAGE_FLOW = 'CCPB/SET_PAGE_FLOW';
export const RESET_CCBP = 'CCBP/RESET_CCBP';
export const RESET_AMOUNT = 'CCBP/RESET_AMOUNT';
export const SET_VAS = 'CCBP/SET_VAS';
export const RESET_VAS = 'CCBP/RESET_VAS';
export const SET_ADDITIONAL_AMOUNT = 'CCBP/SET_ADDITIONAL_AMOUNT';
export const RESET_ADDITIONAL_AMOUNT = 'CCBP/RESET_ADDITIONAL_AMOUNT';
